import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-copy-to-clipboard-button',
  imports: [MatIcon, MatButtonModule],
  templateUrl: './copy-to-clipboard-button.component.html',
  styleUrl: './copy-to-clipboard-button.component.scss'
})
export class CopyToClipboardButtonComponent {
  @Input() valueToCopy: string | null = null;

  copyToClipboard() {
    if (this.valueToCopy && navigator.clipboard) {
      navigator.clipboard.writeText(this.valueToCopy).then(() => {
      }).catch(err => {
        console.error('Kunde inte kopiera till urklipp:', err);
      });
    }
  }
}
